import { Layout, theme, Row, Col, Card } from "antd";
import { useState, useEffect, useContext } from "react";
import {
  DashboardOutlined,
  AppstoreOutlined,
  TeamOutlined,
  TableOutlined,
  UserOutlined,
} from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";

import AdminTopBar from "../../components/TopBar/AdminTopbar";
import AdminSideBar from "../../components/SideBar/AdminSidebar";
import { PolicyPerAgeChart, PolicyPerMonthChart } from "../../components/Chart";

import { AuthContext } from "../../context/AuthContext";

import { getGroupApi } from "../../services/Group/GroupApis";

import "../../styles/Dashboard.css";

const { Content } = Layout;

// const fetcher = async () => await getUsersApi();

const AdminDashboardPage: React.FC = () => {
  // const { data, error } = useSWR("users", fetcher, {
  //   refreshInterval: 3000,
  // });
  const { currentGroup } = useContext(AuthContext);
  const [isActive, setActive] = useState(true);
  const [members, setMembers] = useState([]);
  const [products, setProducts] = useState([]);
  const [policies, setPolices] = useState([]);
  const [users, setUsers] = useState([]);

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  
  useEffect(() => {
    setActive(true);
    getGroupApi(String(currentGroup))
      .then((res) => {
        setMembers(res.data.Member);
        setPolices(res.data.Member.map((item: any) => item.Policy));
        setProducts(res.data.Product);
        setUsers(res.data.User);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setActive(false);
      });
  }, []);

  return (
    <LoadingOverlay active={isActive} spinner>
      <Layout style={{ minHeight: "100vh" }}>
        <AdminSideBar />
        <Layout className="site-layout">
          <AdminTopBar />
          <Content>
            <div
              style={{
                padding: 24,
                minHeight: "100%",
                background: colorBgContainer,
              }}
            >
              <h2>
                <DashboardOutlined
                  style={{ paddingRight: "5px", color: "#f04f05" }}
                />
                Dashboard
              </h2>
              <Row style={{ paddingTop: "24px" }} gutter={[24, 24]}>
                <Col span={6}>
                  <Card title="Active Groups" bordered={false}>
                    <AppstoreOutlined />
                  </Card>
                </Col>
                <Col span={6}>
                  <Card title="Active Policies" bordered={false}>
                    <TeamOutlined />
                  </Card>
                </Col>
                <Col span={6}>
                  <Card title="Active Products" bordered={false}>
                    <TableOutlined />
                  </Card>
                </Col>
                <Col span={6}>
                  <Card title="Pending Users" bordered={false}>
                    <UserOutlined />
                  </Card>
                </Col>
              </Row>

              <Row style={{ paddingTop: "24px" }} gutter={[24, 24]}>
                <Col span={12}>
                  <Card title="Policies Per Month" bordered={true}>
                    <PolicyPerMonthChart policies={policies}/>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card title="Polices Per Age Group" bordered={true}>
                    <PolicyPerAgeChart policies={policies} />
                  </Card>
                </Col>
              </Row>

              <Row style={{ paddingTop: "24px" }} gutter={[24, 24]}>
                <Col span={8}>
                  <Card title="TBD" bordered={true}></Card>
                </Col>
                <Col span={8}>
                  <Card title="TBD" bordered={true}></Card>
                </Col>
                <Col span={8}>
                  <Card title="TBD" bordered={true}></Card>
                </Col>
              </Row>
            </div>
          </Content>
        </Layout>
      </Layout>
    </LoadingOverlay>
  );
};

export default AdminDashboardPage;
